// 7天训练营 - 详情页
let trainingDetails = () =>
  import( /* webpackChunkName: "group-training_details" */ '@/views/training/details/index')
// 7天训练营 - 入学资料
let trainingInformation = () =>
  import( /* webpackChunkName: "group-training_information" */ '@/views/training/information/index')
// 7天训练营 - 详情页（拼团状态）
let trainingDetailsIndex = () =>
  import( /* webpackChunkName: "group-details_index" */ '@/views/training/details_index/index')
// 7天训练营 - 拼团详情
let trainingDetailsSpell = () =>
  import( /* webpackChunkName: "group-details_spell" */ '@/views/training/details_spell/index')
// 7天训练营 - 订单详情
let trainingDetailsOrder = () =>
  import( /* webpackChunkName: "group-details_order" */ '@/views/training/details_order/index')
// 7天训练营 - 班主任微信
let trainingTeacherCode = () =>
  import( /* webpackChunkName: "group-teacher_code" */ '@/views/training/teacher_code/index')
// 7天训练营 - 购买成功
let trainingBuySuccess = () =>
  import( /* webpackChunkName: "group-buy_success" */ '@/views/training/buy_success/index')
// 7天训练营 - 邀请进度
let trainingInvitationProgress = () =>
  import( /* webpackChunkName: "group-invitation_progress" */ '@/views/training/invitation_progress/index')
// 7天训练营 - 海报分享
let trainingMoney = () =>
  import( /* webpackChunkName: "group-training_money" */ '@/views/training/money/index')
// 7天训练营 - 邀请列表
let trainingInvitationList = () =>
  import( /* webpackChunkName: "group-invitation_list" */ '@/views/training/invitation_list/index')
// 推广员邀请
let promotersInvite = () =>
  import( /* webpackChunkName: "group-promoters_invite" */ '@/views/training/promoters_invite/index')
// 招募
let Recruiting = () =>
  import( /* webpackChunkName: "group-recruiting" */ '@/views/training/recruiting/index')
// 推广员下级列表
let PromoteLower = () =>
  import( /* webpackChunkName: "group-promote_lower" */ '@/views/training/promote_lower/index')
// 7天职业定位特训营
let careerOrientation = () =>
  import( /* webpackChunkName: "group-career-orientation" */ '@/views/training/career_orientation/index')
// 7天训练营分班管理
let classInformation = () =>
  import( /* webpackChunkName: "group-class_information" */ '@/views/training/class_information/index')
// 7天训练营分班管理---提交成功
let classInforSuccess = () =>
  import( /* webpackChunkName: "group-class_information" */ '@/views/training/class_information/success')


export default [
    {
        path: '/training_details', //
        name: '加载中',
        component: trainingDetails,
    },
    {
        path: '/training_information', //
        name: '入学资料',
        component: trainingInformation,
    },
    {
        path: '/details_index', //
        name: '加载中',
        component: trainingDetailsIndex,
    },
    {
        path: '/details_spell', //训练营
        name: '拼团详情',
        component: trainingDetailsSpell,
    },
    {
        path: '/details_order', //
        name: '订单详情',
        component: trainingDetailsOrder,
    },
    {
        path: '/teacher_code', //训练营
        name: '班主任微信',
        component: trainingTeacherCode,
    },
    {
        path: '/training_buy_success', //训练营
        name: '购买成功',
        component: trainingBuySuccess,
    },
    {
        path: '/invitation_progress', //训练营
        name: '邀请进度',
        component: trainingInvitationProgress,
    },
    {
        path: '/training_money', //训练营
        name: '海报分享',
        component: trainingMoney,
    },
    {
        path: '/invitation_list', //训练营
        name: '进度详情',
        component: trainingInvitationList,
    },
    {
        path: '/promote_lower',
        name: '推广员下级列表',
        component: PromoteLower
    },
    {
        path: '/promoters_invite',
        name: '推广员邀请',
        component: promotersInvite
    },
    {
        path: '/recruiting',
        name: '招募',
        component: Recruiting
    },
    {
        path: '/career_orientation',
        name: '加载中',
        component: careerOrientation
    },
    {
        path: '/class_information',
        name: '加载中',
        component: classInformation
    },
    {
        path: '/classInfor_success',
        name: '加载中',
        component: classInforSuccess
    }
]


